/* ============================================================================
 * sparklean-award.js  —  Award-grade motion system  (Prestige draft #153474662540 ONLY)
 * Progressive enhancement: ALL content is visible by default. Motion only layers
 * on when GSAP + ScrollTrigger are present AND the user has not asked for reduced
 * motion. A failsafe force-reveals anything still hidden, so content can never get
 * stuck invisible (background tabs, blocked CDN, etc.).
 * Remove the 3 lines in theme.liquid to fully revert.
 * ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function forceShow(el) {
    el.style.opacity = '';
    el.style.transform = '';
    el.classList.add('is-in');
  }

  function init() {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    var reveals = [].slice.call(document.querySelectorAll('[data-award-reveal]'));

    // No motion path: guarantee everything is visible.
    if (reduce || !gsap || !ST) {
      reveals.forEach(forceShow);
      return;
    }

    gsap.registerPlugin(ST);
    document.documentElement.classList.add('award-motion');

    // Scroll reveals (staggered by data-award-order within a shared trigger scope)
    reveals.forEach(function (el) {
      var y = parseFloat(el.getAttribute('data-award-y') || '30');
      var delay = parseFloat(el.getAttribute('data-award-delay') || '0');
      gsap.set(el, { opacity: 0, y: y });
      gsap.to(el, {
        opacity: 1, y: 0, duration: 0.9, ease: 'power3.out', delay: delay,
        scrollTrigger: { trigger: el, start: 'top 90%', once: true }
      });
    });

    // Parallax drift on media
    [].slice.call(document.querySelectorAll('[data-award-parallax]')).forEach(function (el) {
      var amt = parseFloat(el.getAttribute('data-award-parallax') || '8');
      gsap.to(el, {
        yPercent: -amt, ease: 'none',
        scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true }
      });
    });

    // Count-ups (data-award-count="4.89" data-award-decimals="2" data-award-suffix="")
    [].slice.call(document.querySelectorAll('[data-award-count]')).forEach(function (el) {
      var end = parseFloat(el.getAttribute('data-award-count'));
      var dec = parseInt(el.getAttribute('data-award-decimals') || '0', 10);
      var suffix = el.getAttribute('data-award-suffix') || '';
      var prefix = el.getAttribute('data-award-prefix') || '';
      var o = { v: 0 };
      gsap.to(o, {
        v: end, duration: 1.6, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 92%', once: true },
        onUpdate: function () {
          el.textContent = prefix + o.v.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suffix;
        }
      });
    });

    // Magnetic CTA buttons (desktop, fine-pointer only)
    if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      [].slice.call(document.querySelectorAll('[data-award-magnetic]')).forEach(function (btn) {
        btn.addEventListener('mousemove', function (e) {
          var r = btn.getBoundingClientRect();
          var mx = e.clientX - r.left - r.width / 2;
          var my = e.clientY - r.top - r.height / 2;
          gsap.to(btn, { x: mx * 0.25, y: my * 0.35, duration: 0.4, ease: 'power3.out' });
        });
        btn.addEventListener('mouseleave', function () {
          gsap.to(btn, { x: 0, y: 0, duration: 0.5, ease: 'elastic.out(1,0.4)' });
        });
      });
    }

    // Failsafe: reveal anything still at opacity 0 after 3s (e.g. ScrollTrigger
    // mis-fire in a backgrounded/never-scrolled tab).
    setTimeout(function () {
      reveals.forEach(function (el) {
        if (getComputedStyle(el).opacity === '0') { gsap.to(el, { opacity: 1, y: 0, duration: 0.4 }); }
      });
      if (window.ScrollTrigger) { window.ScrollTrigger.refresh(); }
    }, 3000);
  }

  ready(function () {
    // GSAP is loaded with `defer`; poll briefly until it's ready (≈2s max), then init.
    var tries = 0;
    (function wait() {
      if (window.gsap || reduce || tries > 40) { init(); }
      else { tries++; setTimeout(wait, 50); }
    })();
  });
})();

/* ==========================================================================
   Loox widget guard (H-QA 2026-10-22). Loox only allows its reviews iframe on domains it has linked
   (frame-ancestors = *.sparklean.com); on www.sparklean.es the browser blocks it and the iframe stays 0 px,
   leaving an empty padded band. Hide that section until the iframe actually gets a height; re-show it the
   moment Loox resizes it (once sparklean.es is allowed in Loox, this guard never hides anything).
   ========================================================================== */
(function () {
  function guard() {
    var w = document.getElementById('looxReviews');
    if (!w) return;
    var sec = w.closest('.shopify-section');
    if (!sec) return;
    function ok() { var f = w.querySelector('iframe'); return !!f && f.getBoundingClientRect().height > 20; }
    function show() { sec.style.removeProperty('display'); sec.removeAttribute('data-sk-loox-hidden'); }
    new MutationObserver(function () {
      var f = w.querySelector('iframe');
      if (f && parseInt(f.style.height || '0', 10) > 20) show();
    }).observe(w, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'height'] });
    setTimeout(function () {
      if (!ok()) { sec.style.display = 'none'; sec.setAttribute('data-sk-loox-hidden', '1'); }
    }, 8000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', guard); else guard();
})();

/* ==========================================================================
   Market-unavailable product links (H-QA 2026-10-22). Menus are store-level; a product that is not published in the
   visitor's market (e.g. Polishing Cream is US-only) still renders in the header menu but its page 404s there, and
   Liquid still returns the product object, so it can't be filtered server-side. Check each header product link once
   per session per market via /products/<handle>.js (404 = not sold here) and hide it. No Markets change involved.
   ========================================================================== */
(function () {
  function run() {
    var header = document.querySelector('[id$="__header"]');
    if (!header) return;
    var links = [].slice.call(header.querySelectorAll('a[href*="/products/"]'));
    if (!links.length) return;
    var key = 'skProdAvail:' + ((window.Shopify && window.Shopify.country) || '') + ':' + location.host;
    var cache = {};
    try { cache = JSON.parse(sessionStorage.getItem(key) || '{}'); } catch (e) {}
    var byPath = {};
    links.forEach(function (a) {
      var p = new URL(a.getAttribute('href'), location.origin).pathname.replace(/\/$/, '');
      (byPath[p] = byPath[p] || []).push(a);
    });
    Object.keys(byPath).forEach(function (p) {
      function apply(ok) {
        if (ok !== false) return;
        byPath[p].forEach(function (a) { var li = a.closest('li'); (li || a).hidden = true; });
      }
      if (Object.prototype.hasOwnProperty.call(cache, p)) { apply(cache[p]); return; }
      fetch(p + '.js', { credentials: 'same-origin' }).then(function (r) {
        cache[p] = r.ok;
        try { sessionStorage.setItem(key, JSON.stringify(cache)); } catch (e) {}
        apply(r.ok);
      }).catch(function () {});
    });
  }
  if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 3000 }); else setTimeout(run, 1500);
})();

/* ---- PDP, mobile: show the sticky buy bar from first paint ----
   Prestige only shows the bar after the visitor scrolls past the buy buttons, which sit
   ~440 px below the fold on a phone. Showing it at load keeps "Add to cart" on screen.
   Prestige keeps control afterwards: it hides the bar while the real buttons are in view. */
(function () {
  function showStickyBar() {
    try {
      var bar = document.querySelector('product-sticky-bar');
      if (!bar || !window.matchMedia('(max-width: 699px)').matches || window.scrollY > 100) return;
      var formId = bar.getAttribute('form');
      var real = Array.prototype.filter.call(document.querySelectorAll('buy-buttons[form="' + formId + '"]'), function (b) { return !bar.contains(b); })[0];
      if (!real) return;
      if (real.getBoundingClientRect().top > window.innerHeight - 20) bar.classList.add('is-visible');
    } catch (e) {}
  }
  if (document.readyState === 'complete') setTimeout(showStickyBar, 700);
  else window.addEventListener('load', function () { setTimeout(showStickyBar, 700); });
})();

/* ---- Cart: hide zero-value discount badges ----
   The free-gift discount is allocated to every cart line, so the Spray line also shows "FREE SPARKPEN GIFT (-$0.00)".
   Only the line that actually receives the discount keeps its badge. Runs again whenever the cart re-renders. */
(function () {
  var zero = /(^|[^\d])0[.,]00([^\d]|$)/;
  var timer;
  function sweep() {
    try {
      Array.prototype.forEach.call(document.querySelectorAll('.discount-badge'), function (b) {
        var t = (b.textContent || '').replace(/\s+/g, ' ');
        if (/\d/.test(t)) b.hidden = zero.test(t) && !/[1-9]/.test(t.replace(/0[.,]00/g, ''));
      });
    } catch (e) {}
  }
  function later() { clearTimeout(timer); timer = setTimeout(sweep, 120); }
  if (document.readyState !== 'loading') sweep(); else document.addEventListener('DOMContentLoaded', sweep);
  try { new MutationObserver(later).observe(document.body || document.documentElement, { childList: true, subtree: true }); } catch (e) {}
})();
